import { Route } from "react-router-dom";
import RequestOverview from "./requestOverview/requestOverview";
import SearchFlow from "./searchFlow/searchFlow";
import SearchFlowVersionB from "./searchFlowVersionB/searchFlow";
import VafFlow from "./vafFlow/vafFlow";
import RegFlow from "./regFlow/regFlow";
import RegFlowVersionB from "./regFlowVersionB/regFlow";
import ReferralDetails from "./referral/refDetails";
import ReferralPage from "./referral/referralPage";
import ProviderFeedback from "./providerFeedback/providerFeedback";
import DlpProviderProfile from "./dynamicListPages/dlpProviderProfile/dlpProviderProfile";
import DynamicListPages from "./dynamicListPages/dynamicListPages";
import StripeCheckout from "./components/stripePayment/StripeCheckout";
import StripeCTA from "./components/stripePayment/StripeCTA.jsx";
import KftRegFlow from "./kftRegFlow/KftRegFlow";
import KftRegFlowVersionB from "./kftRegFlowVersionB/KftRegFlow";
import VafFlowVersionB from "./vafFlowVersionB/vafFlow";
import HubspotIntermediateRedirect from "./pages/HubspotIntermediateRedirect.jsx";
import WebflowSimulator from "./pages/WebflowSimulator.jsx";

const companyRoutes = (
  <Route path="/company">
    <Route path="/company/webflow-simulator" element={<WebflowSimulator />} />
    <Route
      path="/company/hubspot-intermediate-redirect"
      element={<HubspotIntermediateRedirect />}
    />
    <Route path="/company/request/1" element={<SearchFlow />} />
    <Route path="/company/request/2" element={<SearchFlowVersionB />} />
    <Route path="/company/request/vaf" element={<VafFlow />} />
    <Route path="/company/request/vaf2" element={<VafFlowVersionB />} />
    <Route
      path="/company/request/vaf/checkout"
      element={<StripeCheckout priceId={process.env.REACT_APP_VAF_PRICE_ID} />}
    />
    <Route path="/company/request/reg" element={<RegFlow />} />
    <Route path="/company/request/reg2" element={<RegFlowVersionB />} />
    <Route
      path="/company/request/reg/checkout"
      element={<StripeCheckout priceId={process.env.REACT_APP_EV_PRICE_ID} />}
    />
    <Route path="/company/request/kftreg" element={<KftRegFlow />} />
    <Route path="/company/request/kftreg2" element={<KftRegFlowVersionB />} />
    <Route
      path="/company/request/kftreg/checkout"
      element={
        <StripeCheckout priceId={process.env.REACT_APP_KFT_REG_PRICE_ID} />
      }
    />
    <Route path="/company/request/feedback" element={<ProviderFeedback />} />
    <Route path="/company/request_overview/:id" element={<RequestOverview />} />
    <Route path="/company/refdetails" element={<ReferralDetails />} />
    <Route path="/company/referral" element={<ReferralPage />} />
    <Route
      path="/company/providerprofile/:id"
      element={<DlpProviderProfile />}
    />
    <Route path="/company/providerlists/" element={<DynamicListPages />} />
    <Route path="/company/stripe-cta" element={<StripeCTA />} />
  </Route>
);

export default companyRoutes;
